/**
 * SSE Type Enum
 * - 對齊 Rust SuncakeRustViewer `/v1/channels/{id}/events?type=<X>` 支援的六種 type
 * - 與 Go 端 `apps/SunCakeAPI/model/enum/sse_type.go` 同名同 value
 */
export enum SSETypeEnum {
	/**
	 * 觀眾數量更新
	 */
	Size = 'size',
	/**
	 * 歷史訊息 backfill
	 */
	History = 'history',
	/**
	 * Channel 設定變更
	 */
	Channel = 'channel',
	/**
	 * 翻譯訊息（含 translated_audio_urls）
	 */
	Language = 'language',
	/**
	 * 摘要更新
	 */
	Summary = 'summary',
	/**
	 * 通知訊息（含翻譯/同步/原文/狀態變更/講者更新等所有 NotifyEnum payload）
	 */
	Notify = 'notify',
}
